<template>
  <v-dialog
    max-width="580"
    :value="show"
    @click:outside="close"
    @keydown.esc="close"
  >
    <v-card class="ma-0 pa-0">
      <v-card-title class="ma-0 px-6 py-4">
        <p
          data-testid="revCompletedDialog-text-title"
          class="h6 text--darken-3 ma-0 pa-0"
        >
          {{ $t('rev_cycle.review.great_progress') }}
        </p>
      </v-card-title>

      <v-card-text class="ma-0 px-6 pb-4 pt-1">
        <p
          data-testid="revCompletedDialog-text-description"
          class="body-2 ma-0 pa-0"
        >
          {{ $t('rev.missing_coach_subtitle') }}
        </p>

        <p
          v-if="isCoachAssigned"
          data-testid="revCompletedDialog-text-description"
          class="body-2 ma-0 pa-0 mt-4"
        >
          {{ $t('common.roles.coach_one') }}:
        </p>

        <AssigneesSearchPopover
          :disabled="isCoachAssigned"
          :selectedAccountIds="[coachId]"
          :blacklist="coachBlacklist"
          :filters="{ isCoach: true }"
          @change="handleSelectCoach"
        >
          <ChipAvatar
            v-if="isCoachAssigned"
            :account="coach"
            :vuetifyProps="{
              close: false,
              ripple: false,
            }"
          />

          <v-btn
            v-else
            rounded
            class="blue-grey--text text--darken-1 body-2 mt-6"
            color="blue-grey lighten-3"
            elevation="0"
          >
            <v-icon size="16" class="mr-1" color="blue-grey darken-1">
              mdi-plus
            </v-icon>
            <p class="ma-0 pa-0 blue-grey--text text--darken-1 body-2">
              {{ $t('common.button.select_coach') }}
            </p>
          </v-btn>
        </AssigneesSearchPopover>
      </v-card-text>
      <v-divider class="ma-0 pa-0" />
      <v-card-actions class="d-flex justify-end ma-0 px-6 py-4">
        <Button
          plain
          class="mr-4"
          color="grey"
          data-testid="revCompletedDialog-button-close"
          :text="$t('common.button.close')"
          @click="close"
        />
        <Button
          plain
          color="primary"
          iconPosition="right"
          icon="mdi-arrow-right"
          data-testid="revCompletedDialog-button-markAsCompleted"
          :text="$t('rev.mark_as_completed')"
          @click="complete"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from 'lodash'

import Button from '@/components/UI/Button'

import AssigneesSearchPopover from '@/components/AssigneesSearchPopover/AssigneesSearchPopover.vue'

import ChipAvatar from '@/components/ChipAvatar.vue'
import getEntityId from '@/lib/getEntityId'
import mixin from '@/mixins/mixin.vue'

export default {
  name: 'MissingCoachDialog',

  mixins: [mixin],

  components: {
    Button,
    AssigneesSearchPopover,
    ChipAvatar,
  },

  props: {
    show: {
      type: Boolean,
      required: true,
    },
    revTeam: Object,
    organizationId: String,
  },

  data() {
    return {
      originalCoachId: null,
    }
  },

  watch: {
    show() {
      if (_.isEmpty(this.revTeam.coach)) return (this.originalCoachId = null)
      this.originalCoachId = getEntityId(this.revTeam.coach)
    },
  },

  computed: {
    owner() {
      return this.revTeam?.owner ?? {}
    },

    collaborators() {
      return this.revTeam.collaborators
    },

    coachBlacklist() {
      return _.compact([
        getEntityId(this.owner),
        ...(this.collaborators?.map(collaborator =>
          getEntityId(collaborator)
        ) ?? []),
      ])
    },

    coach() {
      if (_.isEmpty(this.revTeam?.coach)) return null
      return this.revTeam?.coach
    },

    coachId() {
      return getEntityId(this.coach)
    },

    isCoachAssigned() {
      return Boolean(this.coachId)
    },
  },

  methods: {
    close() {
      this.$emit('close')
    },

    complete() {
      if (!this.isCoachAssigned) return this.showError('Please select a coach')
      else return this.$emit('complete')
    },

    handleSelectCoach(selectedUser) {
      this.$emit('setCoach', selectedUser.items?.[0] ?? null)
    },
  },
}
</script>
